import { INPUT_TYPES } from '$gbusiness/enums';
import { input } from '$gbusiness/helpers';
import InputRowModel from '$gbusiness/models/inputRow';

const FORGOT_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        ...INPUT_TYPES.EMAIL,
        placeholder: 'INPUT.PLACEHOLDER.EMAIL',
        validation: [
          input.requiredValidation,
          {
            condition: (v) => !input.validateEmail(v),
            message: 'INVALID_EMAIL',
          },
        ],
        gridSize: 12,
      },
    ],
  },
];

export default FORGOT_FORM;
